import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import { Box, Button, Icon } from "@chakra-ui/react";
import { BiTimeFive } from "react-icons/bi";
import { parseISO as parseISODate, format as formatDate } from "date-fns";
import { dateFnsOptions } from "../../../_utils/dateFnsLocale";
import { translate as trans } from "../Trans/Trans";

const PostEditorDateTimeButton = forwardRef(
  ({ date, time, timezone, ...rest }, ref) => (
    <Button
      {...rest}
      leftIcon={<Icon as={BiTimeFive} fontSize="xl" />}
      ref={ref}
    >
      <Box minWidth="7.5rem">
        <Box fontSize="0.95em">
          {date && time
            ? formatDate(
                parseISODate(`${date} ${time}`),
                "yyyy-MM-dd p",
                dateFnsOptions()
              )
            : trans("post_editor.date_time.not_set")}
        </Box>
        <Box fontSize="0.65em" opacity="0.5">
          {timezone?.replaceAll("_", " ") || ""}
        </Box>
      </Box>
    </Button>
  )
);

PostEditorDateTimeButton.propTypes = {
  date: PropTypes.string,
  time: PropTypes.string,
  timezone: PropTypes.string,
};

PostEditorDateTimeButton.defaultProps = {
  date: undefined,
  time: undefined,
  timezone: undefined,
};

export default memo(PostEditorDateTimeButton);
